import { areaStyle, customStyle, getNode, pointStyle } from "../../../utils/overlaysUtils";
import { NOUVELLE_FENETRE_HTML } from "../../../components/common/NouvelleFenetre";

export const niortInfo = [
    {
        id: "home",
        label: "Risques majeurs",
        items: [
        ],
        infos: [
            {
                title: "RISQUE MAJEUR ?",
                content: 
                    `<p>Tout danger potentiel est un aléa. Il se transforme en risque majeur pour une zone géographique si des enjeux humains, économiques, environnementaux sont exposés. Le risque majeur est donc la rencontre d’un aléa et d’enjeux importants.</p>
                    <p>Il existe 5 types de menaces et risques majeurs :</p>
                    <ul><li>Les risques naturels (Vagues de chaleur, inondations, tempêtes, sécheresses, etc...)</li>
                        <li>Les risques technologiques (Accidents industriels, ruptures de barrages, etc...)</li>
                        <li>Les risques sanitaires / épidémiques (Épidémies, maladies transmises par les moustiques, épizooties, etc...)</li>
                        <li>La menace cyber (Cyberattaques par DDOS, rançongiciels, espionnage, etc...)</li>
                        <li>La menace terroriste (Attentats, radicalisation, etc...)</li>
                    </ul>
                    <div>
                        <div class="fancy-img">
                            <a  data-fancybox="gallery" data-src="https://www.youtube.com/embed/oM7SRcj_Utg?si=rEi2SSnZG_-FC67m">
                                <iframe width="560" height="315" src="https://www.youtube.com/embed/oM7SRcj_Utg?si=rEi2SSnZG_-FC67m?cc_lang_pref=fr&cc_load_policy=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                            </a>
                            <legend>
                                Source : <a href="https://www.youtube.com/@developpementdurable" target="_blank" rel="noopener noreferrer">Ministères Écologie Territoires${NOUVELLE_FENETRE_HTML}</a>
                            </legend>
                        </div>
                    </div>`
            },
            {
                title: "QUE FAIT LA MAIRIE ?",
                content:
                    `<p>
                        Pour tous les risques majeurs, la mairie a élaboré un Plan Communal de Sauvegarde (PCS), il prévoit une organisation spécifique des services municipaux pour faire face à tout évènement de grande ampleur et ainsi prendre en charge la population sinistrée dans les meilleures conditions.
                    </p>
                    <div class="fancy-img">
                        <a data-fancybox="gallery" data-src="/img/ville/niort/pcs.jpg" data-caption="Plan communal de sauvegarde">
                            <img src="/img/ville/niort/pcs.jpg" alt="Plan communal de sauvegarde" />
                        </a>
                    </div>`
            },
            {
                title: "UN RISQUE MAJEUR SURVIENT, COMMENT SUIS-JE ALERTÉ ?",
                content: 
                    `<ul>
                        <li>Par SMS et message vocal sur votre téléphone fixe ou portable Inscription sur www.vivre-a-niort.com</li>
                        <li>Par la sirène de l’hôtel de ville Essai chaque premier mercredi du mois à 12h</li>
                        <li>Par les haut-parleurs sur des véhicules mobiles de la ville</li>
                    </ul>
                    <div class="fancy-img">
                        <a data-fancybox="gallery" data-src="/img/ville/niort/signal_02.jpg">
                            <img src="/img/ville/niort/signal_02.jpg" alt="Image du signal de la sirène" />
                            <div>
                                <audio controls>
                                    <source src="/audio/ville/niort/Signal_national_d_alerte_02.mp3" type="audio/mpeg" />
                                    Votre navigateur ne supporte pas l'audio
                                </audio>
                            </div>
                        </a>
                    </div>`
            },
            {
                title: "COMMENT M’INFORMER ?",
                content: 
                    `<ul>
                        <li>Ecouter la radio, <a href="https://www.francebleu.fr/poitou" target="_blank" rel="noopener noreferrer">France Bleu Poitou 101.0 FM${NOUVELLE_FENETRE_HTML}</a> </li>
                        <li>Consulter <a href="https://www.vivre-a-niort.com" target="_blank" rel="noopener noreferrer">www.vivre-a-niort.com${NOUVELLE_FENETRE_HTML}</a></li>
                        <li>Facebook : <a href="https://www.facebook.com/VilledeNiort/" target="_blank" rel="noopener noreferrer">facebook.com/villedeniort${NOUVELLE_FENETRE_HTML}</a></li>
                        <li>Twitter : <a href="https://twitter.com/Mairie_Niort" target="_blank" rel="noopener noreferrer">@Mairie_Niort${NOUVELLE_FENETRE_HTML}</a></li>
                        <li>Contacter le numéro vert de la Ville de Niort : 0 800 881 329</li>
                        <li>Par inscription à la <a href="https://www.vivre-a-niort.com/cadre-de-vie/risques-majeurs/inscription-au-dispositif-de-telealerte/index.html" target="_blank" rel="noopener noreferrer">téléalerte de la ville de Niort${NOUVELLE_FENETRE_HTML}</a></li>
                    </ul>`
            },
            {
                title: "COMMENT ME PRÉPARER ?",
                content:`<p>
                        En cas de crise, les consignes des autorités peuvent être de quitter immédiatement votre domicile, ou de rester chez vous jusqu’à l’arrivée des secours. Dans les deux cas, il est recommandé d’avoir préparé un sac contenant de quoi vivre pendant 3 jours en autonomie. Voici la liste des objets et équipements essentiels à mettre dans ce kit d’urgence, qui doit rester facilement accessible. Constituez-le sans attendre et vérifier régulièrement son contenu, c’est important.
                     </p>
                     <div class="fancy-img">
                        <a data-fancybox="gallery" data-src="https://www.info.gouv.fr/upload/media/default/0001/05/260665a161009623414b0bbfe1ed00e43089c18f.jpeg" data-caption="Votre kit d'urgence">
                            <img src="https://www.info.gouv.fr/upload/media/default/0001/05/260665a161009623414b0bbfe1ed00e43089c18f.jpeg" alt="Votre kit d'urgence" />
                        </a>
                        <legend>
                            Source : <a href="https://www.info.gouv.fr/" target="_blank" rel="noreferrer noopener">Site officiel du gouvernement${NOUVELLE_FENETRE_HTML}</a>
                        </legend>
                     </div>
                     <div class="fancy-img">
                        <a data-fancybox="gallery" data-src="https://www.youtube.com/embed/8SGtruWuabo?si=nI16U1JP7_M7T0su">
                            <iframe width="560" height="315" src="https://www.youtube.com/embed/8SGtruWuabo?si=nI16U1JP7_M7T0su?cc_lang_pref=fr&cc_load_policy=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                        </a>
                        <legend>
                            Source : <a href="https://www.youtube.com/@gouvernementfr" target="_blank" rel="noopener noreferrer">Chaîne officielle du Gouvernement français${NOUVELLE_FENETRE_HTML}</a>
                        </legend>
                     </div>`
            },
            {
                title: "Plan Individuel de Mise en Sûreté (PIMS)",
                content:`
                    <div class="fancy-img">
                        <a href="https://www.interieur.gouv.fr/content/download/136519/1080657/file/PIMS-def-net-2.pdf" target="_blank" rel="noreferrer noopener" title="Plan Individuel de Mise en Sûreté (PIMS) - PDF (nouvelle fenêtre)">
                            <img src="/img/ville/niort/pims.png" alt="Plan Individuel de Mise en Sûreté (PIMS)" />
                            ${NOUVELLE_FENETRE_HTML}
                        </a>
                        <legend>
                            Source : <a href="https://www.interieur.gouv.fr/Le-ministere/Securite-civile/Nos-missions/La-protection-des-personnes-des-biens-et-de-l-environnement/Le-plan-individuel-de-mise-en-surete-PIMS" target="_blank" rel="noopener noreferrer">Ministère de l'Intérieur et des Outre-Mer${NOUVELLE_FENETRE_HTML}</a>
                        </legend>
                    </div>`
            }
        ],
        medias: []
    },
    {
        id: "risques-naturels",
        label: "Risques naturels",
        items: [
            {
                id: "inondation",
                label: "Inondation",
                infos: [
                    {
                        title: "QU’EST-CE QUE C’EST ?",
                        content: 
                            `<p>Une inondation est un phénomène temporaire qui peut submerger de vastes parties du lit mineur ou de la plaine, suite au débordement des eaux.</p>`
                    }
                ],
                medias: [
                    {
                        title: "TutosRisques : Inondation",
                        type: "video",
                        thumbnail: "/img/ville/niort/risques-naturels/inondation/tutorisques-inondation.png",
                        src: "https://www.youtube.com/embed/n-5ltuDogF4?si=Z62JSpg8xc520Xzn",
                        source: {
                            name: "Chaîne officielle du Gouvernement français",
                            url: "https://www.youtube.com/gouvernementfr"
                        }
                    },
                    {
                        title: "AFPCNT Risques Ruissellement",
                        type: "video",
                        thumbnail: "/img/ville/niort/risques-naturels/inondation/inondation-par-ruissellement.png",
                        src: "https://www.youtube.com/embed/hqndv3xzNUk?si=EXbYoMflMu2v5lYY",
                        source: {
                            name: "Chaîne officielle de l'Association Française pour la Prévention des Catastrophes Naturelles (AFPCN)",
                            url: "https://www.youtube.com/@associationafpcnt8974"
                        }
                    },
                    {
                        title: "Que faire en cas d'inondation ?",
                        type: "pdf",
                        thumbnail: "/img/ville/niort/risques-naturels/inondation/georisques-inondation.png",
                        src: "https://www.georisques.gouv.fr/sites/default/files/2022-08/Bons%20Reflexes_a_INONDATION_A4-HD.pdf",
                        source: {
                            name: "Géorisques",
                            url: "https://www.georisques.gouv.fr/"
                            }
                    },
                    {
                        title: "Comment réduire la vulnérabilité de sa maison aux inondations ?",
                        type: "pdf",
                        thumbnail: "/img/ville/niort/risques-naturels/inondation/affiche-vulnerabilite-inondation.png",
                        src: "https://georisques.gouv.fr/sites/default/files/2022-08/Vuln%C3%A9rabilit%C3%A9_Maison_Inondation_BAM.pdf",
                        source: {
                            name: "Géorisques",
                            url: "https://www.georisques.gouv.fr/"
                            }
                    }
                ],
                maps: [
                    {
                        tilesId: "score_inondation_actuel",
                        style: (properties) => areaStyle(properties.color),
                        summaryRiskNode: (summary) => getNode(summary, ['naturels', 'inondations','scores','actuel']),
                        popupContent: (properties) => `Niveau d'exposition : ${properties.label}`
                    }
                ]
            },
            {
                id: "crues_a_niort",
                label: "Crues à Niort",
                infos: [
                    {
                        title: "QU’EST-CE QUE C’EST ?",
                        content:
                            `<p>Ce phénomène naturel périodique est exceptionnel lorsque les débits deviennent plus importants que le régime moyen habituel de la Sèvre niortaise 
                            que vous pouvez suivre en temps réel sur <a href="https://www.vigicrues.gouv.fr/station/N430062002" target="_blank" rel="noopener noreferrer">Vigicrues${NOUVELLE_FENETRE_HTML}</a> et visualiser son impact sur la cartographie sélectionnant le débit correspondant.</p>`
                    },
                    {
                        title: "LE SAVIEZ-VOUS ?",
                        content: 
                            `<p>11 repères de crues ont été installés le long de la Sèvre niortaise et du Lambon en 2013.</p>`
                    },
                    {
                        title: "LES SCÉNARIOS DE DÉBIT DE LA STATION VIGICRUE « LA TIFFARDIÈRE »",
                        content:
                            `<table>
                                <thead><tr><th>Débit Station Vigicrue « La Tiffardière »</th><th>Cote VIEUX PONT (en mètres NGF 69)</th></tr></thead>
                                <tbody>
                                    <tr><td>Scénario 125m<sup>3</sup>/s</td><td>&lt;12,50</td></tr>
                                    <tr><td>Scénario 150m<sup>3</sup>/s</td><td>&gt;12,50</td></tr>
                                    <tr><td>Scénario 170m<sup>3</sup>/s</td><td>&gt;12,80</td></tr>
                                    <tr><td>Scénario 190m<sup>3</sup>/s</td><td>&gt;13,30</td></tr>
                                    <tr><td>Scénario 225m<sup>3</sup>/s</td><td>&gt;13,70</td></tr>
                                    <tr><td>Scénario 260m<sup>3</sup>/s</td><td>&gt;14,10</td></tr>
                                    <tr><td>Scénario 290m<sup>3</sup>/s</td><td>&gt;14,50</td></tr>
                                    <tr><td>Scénario 320m<sup>3</sup>/s</td><td>&gt;14,80</td></tr>
                                    <tr><td>Scénario 360m<sup>3</sup>/s</td><td>&gt;15,20</td></tr>
                                </tbody>
                            </table>`
                    },
                    {
                        title: "LES DERNIÈRES CRUES A NIORT",
                        content:
                            `<table>
                                <thead><tr><th>Crues Historiques</th><th>Cote VIEUX PONT</th></tr></thead>
                                <tbody>
                                    <tr><td>Février 1906</td><td>13,93 m</td></tr>
                                    <tr><td>Décembre 1936</td><td><strong>14,18 m</strong></td></tr>
                                    <tr><td>Février 1955</td><td>13,58 m</td></tr>
                                    <tr><td>Janvier 1961</td><td>13,91 m</td></tr>
                                    <tr><td>Janvier 1962</td><td>13,58 m</td></tr>
                                    <tr><td>Décembre 1982</td><td>14,15 m</td></tr>
                                    <tr><td>Avril 1983</td><td>13,52 m</td></tr>
                                    <tr><td>Décembre 1992</td><td>13,17 m</td></tr>
                                    <tr><td>Janvier 1994</td><td>13,55 m</td></tr>
                                    <tr><td>Janvier 1995</td><td>13,60 m</td></tr>
                                </tbody>
                            </table>`
                    },
                ],
                medias: [
                    {
                        title: "Les inondations à Niort",
                        type: "video",
                        thumbnail: "/img/ville/niort/risques-naturels/inondation/inondation-niort.png",
                        src: "https://player.vimeo.com/video/754337280?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
                        source: {
                            name: "NiortAgglo TV",
                            url: "https://vimeo.com/user141842806"
                        }
                    },
                    {
                        title: "Plan de Prévention du Risque Inondation (PPRi) - Note de présentation",
                        type: "pdf",
                        thumbnail: "/img/ville/niort/risques-naturels/inondation/ppri.png",
                        src: "https://www.vivre-a-niort.com/fileadmin/ville/archives/fichiers/Docpdf/risques_majeurs/PPRi_Niort_-_1.1_-_Note_presentation.pdf",
                        source: {
                            name: "Vivre à Niort",
                            url: "https://www.vivre-a-niort.com/cadre-de-vie/risques-majeurs/inondation/index.html"
                        }
                    },
                    {
                        title: "Plan de Prévention du Risque Inondation (PPRi) - Guide",
                        type: "pdf",
                        thumbnail: "/img/ville/niort/risques-naturels/inondation/ppri.png",
                        src: "https://www.vivre-a-niort.com/fileadmin/ville/archives/fichiers/Docpdf/risques_majeurs/PPRi_Niort_-_1.3_-_Guide.pdf",
                        source: {
                            name: "Vivre à Niort",
                            url: "https://www.vivre-a-niort.com/cadre-de-vie/risques-majeurs/inondation/index.html"
                        }
                    },
                    {
                        title: "Plan de Prévention du Risque Inondation (PPRi) - Réglement",
                        type: "pdf",
                        thumbnail: "/img/ville/niort/risques-naturels/inondation/ppri.png",
                        src: "https://www.vivre-a-niort.com/fileadmin/ville/archives/fichiers/Docpdf/risques_majeurs/PPRi_Niort_-_2.1_-_Reglement.pdf",
                        source: {
                            name: "Vivre à Niort",
                            url: "https://www.vivre-a-niort.com/cadre-de-vie/risques-majeurs/inondation/index.html"
                        }
                    },
                    {
                        title: "Plan de Prévention du Risque Inondation (PPRi) - Carte de zonage",
                        type: "pdf",
                        thumbnail: "/img/ville/niort/risques-naturels/inondation/ppri.png",
                        src: "https://www.vivre-a-niort.com/fileadmin/ville/archives/fichiers/Docpdf/risques_majeurs/carte_PPRi_Niort_01.pdf",
                        source: {
                            name: "Vivre à Niort",
                            url: "https://www.vivre-a-niort.com/cadre-de-vie/risques-majeurs/inondation/index.html"
                        }
                    }
                ],
                maps: [125, 150, 170, 190, 225, 260, 290, 320, 360, 420].map((scenario, idx) => {
                    return {
                        tilesId: `niort_inondation_scenario_${scenario}`,
                        layerLabel: `Scénario ${scenario}m³`,
                        legendLabel: `Hauteur de crue selon le scénario`,
                        attributions: "Niort Agglo",
                        style: (properties) => areaStyle(properties.color),
                        summaryRiskNode: (summary) => { return {}; },
                        popupContent: (properties) => properties.label,
                        showInLayersControl: true,
                        showLegend: idx === 0
                    };
                }).concat([
                    {
                        tilesId: 'niort_repere_crue',
                        legendLabel: 'Repères de crue',
                        attributions: "Niort Agglo",
                        style: (properties) => pointStyle(properties.color),
                        summaryRiskNode: (summary) => { return {}; },
                        popupContent: (properties) => `Repère ${properties.numero_laisse}<br>Hauteur : ${parseFloat(properties.hauteur_repere).toFixed(2)}`
                    }
                ])
            },
            {
                id: "meteorologique",
                label: "Météorologique",
                infos: [
                    {
                        title: "QU’EST-CE QUE C’EST ?",
                        content: 
                        `<p>Tempête, orage, canicule, grand froid, neige et verglas sont autant de risques météorologiques qui peuvent survenir. Ces conditions climatiques peuvent provoquer des dommages, voire porter atteinte à
                        la sécurité des personnes. Quotidiennement des cartes de vigilance sont diffusées par METEO France.</p>`
                    },
                    {
                        title: "LE SAVIEZ-VOUS ?",
                        content: 
                            `<p>Le plan canicule est déclenché lorsque les températures dépassent 35° le jour et 20° la nuit pendant au moins 3 jours consécutifs. Une attention particulière est portée aux plus de 65 ans et aux personnes isolées.</p>`
                    },
                    {
                        title: "MÉMOIRE DU RISQUE",
                        content: 
                            `<ul>
                                <li>27 décembre 1999 : Tempête 144 km/h</li>
                                <li>Juillet - août 2003 : + 40°C</li>
                                <li>Janvier 1987 : Vague de froid</li>
                                <li>Février 1972 : 15 cm de neige</li>
                            </ul>`
                    },
                ],
                medias: [
                    {
                        title: "Explication des vigilances météo départementales",
                        type: "img",
                        src: "/img/ville/niort/risques-naturels/meteorologique/explication-vigilance.png",
                        source: {
                            name: "Guide de prévention des risques à Niort",
                            url: "https://www.vivre-a-niort.com/fileadmin/ville/cadre_de_vie/risques_majeurs/Guide_prevention_risques.pdf"
                        }
                    },
                    {
                        title: "TutosRisques : Foudre et orage",
                        type: "video",
                        thumbnail: "/img/ville/niort/risques-naturels/meteorologique/tutorisques-foudre.png",
                        src: "https://www.youtube.com/embed/E-oSPTJZy6w?si=cNIOHL-t21k_TfAh",
                        source: {
                            name: "Chaîne officielle du Gouvernement français",
                            url: "https://www.youtube.com/gouvernementfr"
                        }
                    },
                    {
                        title: "TutosRisques : Forte chaleur",
                        type: "video",
                        thumbnail: "/img/ville/niort/risques-naturels/meteorologique/tutorisques-forte-chaleur.png",
                        src: "https://www.youtube.com/embed/i_w1lyN-Er8?si=DGR6vSjHTDRxqBM4",
                        source: {
                            name: "Chaîne officielle du Gouvernement français",
                            url: "https://www.youtube.com/gouvernementfr"
                        }
                    },
                    {
                        title: "TutosRisques : Froid intense",
                        type: "video",
                        thumbnail: "/img/ville/niort/risques-naturels/meteorologique/tutorisques-froid-intense.png",
                        src: "https://www.youtube.com/embed/EMlIPOMC4Ts?si=FI7B51Iq2aJ1Czoe",
                        source: {
                            name: "Chaîne officielle du Gouvernement français",
                            url: "https://www.youtube.com/gouvernementfr"
                        }
                    }
                ]
            },
            {
                id: "argiles",
                label: "Retrait et gonflement des argiles",
                infos: [
                    {
                        title: "QU’EST-CE QUE C’EST ?",
                        content: 
                            `<p>Ce risque se manifeste dans les sols argileux. Lors des périodes de sécheresse, l’eau contenue dans les couches d’argile s’évapore et les sols se rétractent. Le manque d’eau entraîne un tassement irrégulier
                            du sol en surface, on parle alors de « retrait ». Inversement un nouvel apport d’eau important dans ces terrains produit un phénomène de « gonflement ». Ce risque est sans danger immédiat
                            pour l’homme mais il peut provoquer divers désordres sur les constructions (fissuration essentiellement).</p>`
                    }
                ],
                medias: [
                    {
                        title: "AFPCNT Risques Retrait-Gonflement des argiles",
                        type: "video",
                        thumbnail: "/img/ville/niort/risques-naturels/afpcnt-argiles.png",
                        src: "https://www.youtube.com/embed/bhw_QYc3cfQ?si=TZ9m-2nQrbAd47Xi",
                        source: {
                            name: "Chaîne officielle de l'Association Française pour la Prévention des Catastrophes Naturelles (AFPCN)",
                            url: "https://www.youtube.com/@associationafpcnt8974"
                        }
                    }
                ],
                maps: [
                    {
                        tilesId: "argiles",
                        style: (properties) => areaStyle(properties.color),
                        summaryRiskNode: (summary) => getNode(summary, ['naturels', 'argiles']),
                        popupContent: (properties) => `Niveau d'exposition : ${properties.label}`
                    }
                ]
            },
            {
                id: "cavites",
                label: "Risques cavités souterraines",
                infos: [
                    {
                        title: "QU’EST-CE QUE C’EST ?",
                        content: 
                            `<p>Les cavités souterraines sont des vides situés sous la terre. Certaines résultent de l’infiltration d’eau dans des roches sédimentaires ou
                            d’activités volcaniques passées. D’autres (galeries d’anciennes mines ou carrières, vestiges militaires…) représentent un risque en cas d’absence d’entretien.</p>`
                    },
                    {
                        title: "MESURES PREVENTIVES",
                        content: 
                            `<p>Avant toute construction importante, faites réaliser une étude de sol pour vous renseigner sur la nature de celui-ci et choisir les fondations adaptées.</p>`
                    },
                    {
                        title: "BASE LEGALE",
                        content: 
                            `<p>Toute personne informée de l'existence d'une cavité souterraine sous un terrain, ou même d'un indice de cette existence, a l'obligation d'en faire part à sa municipalité (article L. 563-6 du code de l'environnement).</p>`
                    }
                ],
                medias: [
                    {
                        title: "AFPCNT Risques Mouvements terrains",
                        type: "video",
                        thumbnail: "/img/ville/niort/risques-naturels/afpcnt-mouvements-terrains.png",
                        src: "https://www.youtube.com/embed/tylln_UUHZ0?si=FFExaXv719Fv-dQV",
                        source: {
                            name: "Chaîne officielle de l'Association Française pour la Prévention des Catastrophes Naturelles (AFPCN)",
                            url: "https://www.youtube.com/@associationafpcnt8974"
                        }
                    }
                ],
                maps: [
                    {
                        tilesId: "niort_cavite",
                        attributions: "Niort Agglo",
                        style: (properties, valuesRef) => {
                            const value = valuesRef.find(v => v.label.toLowerCase() === properties.type_cavite.toLowerCase());
                            if(value){
                                return value.shape === 'circle'? pointStyle(value.color) : customStyle(`${value.shape}${value.color.substring(1)}`)
                            }
                            return pointStyle('#000', '#fff')
                        },
                        summaryRiskNode: (summary) => { return {}; },
                        popupContent: (properties) => `Type de cavité : ${properties.type_cavite}<br>Nature de cavité : ${properties.nature_cavite}`
                    }
                ]
            },
            {
                id: "seismes",
                label: "Risque sismique",
                infos: [
                    {
                        title: "QU’EST-CE QUE C’EST ?",
                        content: 
                            `<p>Un tremblement de terre est provoqué par une fracture brutale des roches en profondeur créant des failles dans le sol ou en surface, qui
                            peuvent affecter les bâtiments et les infrastructures, occasionner des chutes d’objets ou d’éléments sur les personnes.</p>`
                    },
                    {
                        title: "C'EST QUOI L'ECHELLE DE RICHTER ? (Magnitude)",
                        content: 
                            `<p>Elle a été définie en 1935 par Charles F. Richter qui a établit une échelle pour classer et comparer les séismes selon un certain protocole et avec un certain type d'instrument. Cette mesure correspond à un type de magnitude appelée magnitude locale (MI) et qui n'est en fait valable que pour des séismes proches des insstruments.</p>`
                    },
                    {
                        title: "C'EST QUOI L'ECHELLE EMS98 ? (Intensité)",
                        content: 
                            `<p>L'échelle utilisée actuellement en Europe pour mesurer l'<a href="https://www.epos-france.fr/glossary/intensite/" target="_blank" rel="noreferrer noopener">intensité${NOUVELLE_FENETRE_HTML}</a> des séisme et leurs effets est l'EMS-98 (European Macroseismic Scale 1998). Elle comprend douze degrés notés généralement en chiffres romains de I à XII. Le degré I correspond aux secousses les plus faibles, non ressenties, tandis que le degré XII exprime une destruction totale du paysage.</p>`
                    }
                ],
                medias: [
                    {
                        title: "TutosRisques : Séisme",
                        type: "video",
                        thumbnail: "/img/ville/niort/risques-naturels/seisme/tutorisques-seisme.png",
                        src: "https://www.youtube.com/embed/Q3SsZF-iY08?si=ARKYVvZdumlZIsLP",
                        source: {
                            name: "Chaîne officielle du Gouvernement français",
                            url: "https://www.youtube.com/@gouvernementfr"
                        }
                    },
                    {
                        title: "AFPCNT Risques Séismes",
                        type: "video",
                        thumbnail: "/img/ville/niort/risques-naturels/seisme/afpcnt-seisme.png",
                        src: "https://www.youtube.com/embed/bbDP-bJoNNg?si=Iguzg5qhgMXDbZEB",
                        source: {
                            name: "Chaîne officielle de l'Association Française pour la Prévention des Catastrophes Naturelles (AFPCN)",
                            url: "https://www.youtube.com/@associationafpcnt8974"
                        }
                    },
                    {
                        title: "Que faire en cas de séisme ?",
                        type: "pdf",
                        thumbnail: "/img/ville/niort/risques-naturels/seisme/georisques-seismes.png",
                        src: "https://www.georisques.gouv.fr/sites/default/files/2022-08/Bons%20Reflexes_c_SEISME_A4-HD.pdf",
                        source: {
                            name: "Géorisques",
                            url: "https://www.georisques.gouv.fr/"
                        }
                    },
                    {
                       title: "Intensité EMS",
                       type: "img",
                       thumbnail: "/img/ville/niort/risques-naturels/seisme/intensite-ems.png",
                       src: "https://www.mementodumaire.net/wp-content/uploads/2012/03/2.1-intensite.jpg",
                       source: {
                            name: "Mémento du maire et des élus locaux",
                            url: "https://www.mementodumaire.net/les-risques-naturels/rn-6-seismes-et-tsunami/"
                        }
                    },
                    {
                        title: "Liste des derniers évènements sismiques en France",
                        type: "site",
                        thumbnail: "/img/ville/niort/risques-naturels/seisme/renass-liste-derniers-seismes-france.png",
                        src: "https://renass.unistra.fr/fr/zones/france/",
                        source: {
                            name: "RENASS",
                            url: "https://renass.unistra.fr/fr/zones/france/"
                        }
                     }
                ],
                alternativeMap: {
                    title: "Zonage sismique de la France",
                    type: "img",
                    src: "/img/ville/niort/risques-naturels/seisme/carte-seisme-france.png",
                    source: {
                        name: "Carmen",
                        url: "https://carmen.naturefrance.fr/"
                    }
                }
            }
        ]
 
    },
    {
        id: "risques-technologiques",
        label: "Risques technologiques",
        items: [
            {
                id: "industriel",
                label: "Risque industriel",
                infos: [
                    {
                        title: "QU’EST-CE QUE C’EST ?",
                        content: 
                            `<p>Certains sites industriels accueillent des établissements dits dangereux. Un évènement accidentel peut alors entrainer des conséquences immédiates et graves en raison de la nature et la
                            quantité des produits stockés. Le risque industriel peut se manifester par un incendie, une explosion ou un nuage toxique.</p>`
                    },
                    {
                        title: "LE SAVIEZ VOUS ?",
                        content: 
                            `<p>Ces entreprises industrielles sont soumises à la législation sur les installations classées pour la protection de l’environnement. Des études de danger analysées et validées par les services de l’Etat
                            permettent de connaître les dangers potentiels. Ces établissements subissent un contrôle régulier de leurs installations et réalisent des exercices.</p>
                            <p>Les industries classées SEVESO et la Préfecture élaborent des plans pour assurer la sécurité à l’intérieur et à l’extérieur de l’établissement : Le Plan d’Opération Interne (POI) et le Plan particulier d’Intervention
                            (PPI) qui organisent la réponse de sécurité civile en cas d’accident industriel.</p>`
                    }
                ],
                medias: [
                    {
                        title: "AFPCNT : Risques Accidents Industriels",
                        type: "video",
                        thumbnail: "/img/ville/niort/risques-technologiques/risques-industriels.png",
                        src: "https://www.youtube.com/embed/3oUwvmk-5gY?si=Hr-VvV7yYkIH6DAZ",
                        source: {
                            name: "Chaîne officielle de l'Association Française pour la Prévention des Catastrophes Naturelles (AFPCN)",
                            url: "https://www.youtube.com/@associationafpcnt8974"
                        }
                    },
                    {
                        title: "Que faire en cas d'accident industriel ?",
                        type: "pdf",
                        thumbnail: "/img/ville/niort/risques-technologiques/georisques-industriel.png",
                        src: "https://www.georisques.gouv.fr/sites/default/files/2022-08/Bons%20Reflexes_d_INDUSTRIEL_A4-HD.pdf",
                        source: {
                            name: "Géorisques",
                            url: "https://www.georisques.gouv.fr/"
                        }
                    },
                    {
                        title: "Plan de prévention des risques technologiques (PPRT)",
                        type: "pdf",
                        thumbnail: "/img/ville/niort/risques-technologiques/pprt-niort.png",
                        src: "https://www.niortagglo.fr/fileadmin/CAN/habiter_etudier/urbanisme/pluid/Approbation/6.PLUi-D_Niort_Agglo_Annexes/6.1.Annexes_SUP/6.1.5.Annexes_SUP_PPRT/6.1.5.1.Annexes_SUP_PPRT_SIGAP.pdf",
                        source: {
                            name: "Niort Agglo",
                            url: "https://www.niortagglo.fr/"
                        }
                    },
                    {
                        title: "Dossier Départemental des risques majeurs (DDRM)",
                        type: "pdf",
                        thumbnail: "/img/ville/niort/risques-technologiques/ddrm-deux-sevres.png",
                        src: "https://www.deux-sevres.gouv.fr/contenu/telechargement/35803/271748/file/DDRM_79_2020.pdf",
                        source: {
                            name: "Les services de l'Etat dans les Deux-Sèvres",
                            url : "https://www.deux-sevres.gouv.fr/"
                        }
                    }
                ],
                maps: [
                    {
                        tilesId: "niort_icpe",
                        attributions: "Niort Agglo",
                        style: (properties) => {
                            return areaStyle(properties.color);
                        },
                        summaryRiskNode: (summary) => { return {}; },
                        popupContent: (properties) => `${properties.activite} - ${properties.classement}`
                    }
                ]
            },
            {
                id: "rupture-barrage",
                label: "Risque de rupture de barrage", 
                infos: [
                    {
                        title: "QU’EST-CE QUE C’EST ?",
                        content: 
                            `<p>La rupture d’un barrage entrainant une onde de submersion peut être due à une défaillance technique, une erreur humaine ou à un aléa naturel.</p>
                            <p>En cas de rupture du barrage de la Touche Poupard situé à 47 km en amont de Niort, une onde de submersion atteindra la commune dans un délai de 05h30. La hauteur maximum d’élévation de la Sèvre serait de + 4 mètres.</p>`
                    },
                    {
                        title: "LE SAVIEZ VOUS ?",
                        content: 
                            `<p>Exploitée par la société publique locale des eaux de la Touche Poupard, une surveillance constante est assurée notamment les mesures de fissuration, la pression de l’eau ….</p>
                            <p>Un plan de secours (Plan Particulier d’Intervention) est prévu par la Préfecture pour mettre en œuvre toutes les mesures d’urgence en cas d’accident.</p>`
                    }
                ],
                medias: [
                    {
                        title: "La sécurité des ouvrages hydrauliques",
                        type: "video",
                        thumbnail: "/img/ville/niort/risques-technologiques/securite-barrage.png",
                        src: "https://player.vimeo.com/video/841164648?h=d3980a2cc3&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
                        source: {
                            name: "Biplan, l'agence vidéo",
                            url: "https://vimeo.com/actamedia"
                        }
                    }
                ],
                maps: [
                    {
                        tilesId: "niort_barrage_zone_submersible",
                        legendLabel: 'Zone submersible',
                        attributions: "Niort Agglo",
                        style: (properties) => {
                            return areaStyle(properties.color);
                        },
                        summaryRiskNode: (summary) => { return {}; }
                    },
                    {
                        tilesId: "niort_barrage_temps_front",
                        legendLabel: 'Front d\'onde',
                        attributions: "Niort Agglo",
                        style: (properties) => {
                            return pointStyle(properties.color);;
                        },
                        summaryRiskNode: (summary) => { return {}; },
                        popupContent: (properties) => { return `Temps d'arrivée : ${properties.temps}`; }
                    }
                ]
            },
            {
                id: "transport-matieres-dangereuses",
                label: "Transport de matières dangereuses",
                infos: [
                    {
                        title: "QU’EST-CE QUE C’EST ?",
                        content:
                            `<p>Les accidents liés au transport de matières dangereuses (TMD) concernent les axes routiers, ferroviaires et les canalisations de TMD. Ce type d’accident engendre un risque d’explosion, toxique ou d’incendie.</p>
                            <p>A Niort, ce risque est localisé autour des principaux axes routiers et peut inclure la voie ferroviaire et la canalisation souterraine de gaz naturel qui parcourt la partie nord de la zone d’activité de Niort -Souché.</p>`
                    },
                    {
                        title: "LE SAVIEZ VOUS ?",
                        content: 
                            `<p>En cas d’accident, un plan de secours TMD peut être activé par le Préfet avec le déploiement de la cellule mobile d’intervention chimique du SDIS.</p>
                            <p>Il existe différents types de pictogrammmes :</p><img src="/img/ville/niort/risques-technologiques/pictogrammes.png" alt="Liste des différents pictogrammes illustrant les matières dangereuses" />`
                    }
                ],
                medias: [
                    {
                        title: "Risque Transport de Matières Dangereuses",
                        type: "pdf",
                        thumbnail: "/img/ville/niort/risques-technologiques/risque-TDM.png",
                        src: "https://www.deux-sevres.gouv.fr/contenu/telechargement/35803/271748/file/DDRM_79_2020.pdf#page=117",
                        source: {
                            name: "Les services de l'Etat dans les Deux-Sèvres",
                            url : "https://www.deux-sevres.gouv.fr/"
                        }
                    }
                ]
            },
            {
                id: "nucleaire",
                label: "Risque nucléaire",
                infos: [
                    {
                        title: "QU’EST-CE QUE C’EST ?",
                        content:
                            `<p>Un accident nucléaire est un évènement qui se produit sur une installation nucléaire suite à une erreur humaine, à un dysfonctionnement des systèmes ou à un élément externe (acte de malveillance, séisme, …)</p>
                            <p>Les centrales de Chinon, de Blaye, et de Civaux sont toutes les trois situées dans un périmètre d’une centaine de kilomètres de Niort. Les enfants, adolescents, jeune adultes, femmes enceintes sont les plus vulnérables au risque radioactif.</p>`
                    },
                    {
                        title: "LE SAVIEZ VOUS ?",
                        content: 
                            `<p>L’organisme peut être exposé à la radioactivité de deux manières :</p><ul>
                                <li>Par irradiation (exposition aux rayonnements radioactifs)</li>
                                <li>Par contamination (particules radioactives se déposent sur la peau, sont avalées ou respirées)</li>
                            </ul>
                            <p>En cas d’accident nucléaire, la Préfecture a élaboré un plan départemental de distribution d’iode.</p><img src="/img/ville/niort/risques-technologiques/distribution-iode.png" alt="Posologie de distribution d'iode"/>`
                    }
                ],
                medias: [
                    {
                        title: "Carte des sites nucléaires",
                        type: "img",
                        src: "https://www.georisques.gouv.fr/sites/default/files/2023-10/carte%20INB-01-09-2023.png",
                        source: {
                            name: "Géorisques",
                            url: "https://www.georisques.gouv.fr/"
                        }
                    },
                    {
                        title: "Que faire en cas d'accident nucléaire ?",
                        type: "pdf",
                        thumbnail: "/img/ville/niort/risques-technologiques/georisques-nucleaire.png",
                        src: "https://www.georisques.gouv.fr/sites/default/files/2022-08/Bons%20Reflexes_e_NUCLEAIRE_A4-HD.pdf",
                        source: {
                            name: "Géorisques",
                            url: "https://www.georisques.gouv.fr/"
                        }
                    }
                ]
            }
        ]
    },
    {
        id: "risques-societaux",
        label: "Risques sociétaux",
        items: [
            {
                id: "terrorisme",
                label: "Terrorisme",
                infos: [
                    {
                        title: "Le Plan Vigipirate",
                        content: 
                            `<p>Le Plan Vigipirate est un outil central du dispositif français de lutte contre le terrorisme. Il associe tous les nationaux de l’Etat, des collectivités territoriales, des opérateurs publics et privés et les citoyens à une démarche de vigilance, de prévention et de protection.</p>`
                    }
                ],
                medias: [
                    {
                        title: "Les niveaux vigipirate",
                        type: "pdf",
                        thumbnail: "/img/ville/niort/niveau-vigipirate.png",
                        src: "https://www.sgdsn.gouv.fr/files/files/Vigipirate/vigipirate-web2-14-03.pdf",
                        source: {
                            name: "Secrétariat général de la défense et de la sécurité nationale (SGDSN)",
                            url: "https://www.sgdsn.gouv.fr/"
                        }
                    },
                    {
                        title: "Faire face ensemble",
                        type: "site",
                        thumbnail: "/img/ville/niort/faire-face-ensemble.png",
                        src: "https://vigipirate.gouv.fr/"
                    },
                    {
                        title: "Réagir en cas d'attaque",
                        type: "pdf",
                        thumbnail: "/img/ville/niort/risques-societaux/reagir-cas-attaque.png",
                        src: "https://www.info.gouv.fr/upload/media/content/0001/07/7dd5c6d58d19921ca127f1275020abf3cad5a5a5.pdf",
                        source: {
                            name: "Site officiel du gouvernement",
                            url: "https://www.info.gouv.fr/"
                        }
                    },
                    {
                        title: "Que faire en cas d'exposition à un gaz toxique ?",
                        type: "pdf",
                        thumbnail: "/img/ville/niort/risques-societaux/exposition-gaz-toxique.png",
                        src: "https://www.info.gouv.fr/upload/media/content/0001/07/210f465175786c45712debda76be46c77256d768.pdf",
                        source: {
                            name: "Secrétariat général de la défense et de la sécurité nationale (SGDSN)",
                            url: "https://www.sgdsn.gouv.fr/"
                        }
                    }
                ]
            },
            {
                id: "cyber",
                label: "Risque Cyber",
                infos: [
                    {
                        title: "Les attaques cyber",
                        content: 
                            `<p>Les attaques cyber peuvent cibler les particuliers mais aussi les entreprises et les administrations.Elles visent à obtenir des informations personnelles afin de les exploiter ou de les revendre (données bancaires, identifiants à des sites
                            marchands, etc...). L'hameçonnage (« phishing ») et le « rançongiciel » sont des exemples connus d'actes malveillants portant préjudice aux internautes.</p>`
                    }
                ],
                medias: [
                    {
                        title: "Assitance et prévention en sécurité numérique",
                        type: "site",
                        thumbnail: "/img/ville/niort/risques-societaux/cybermalveillance.png",
                        src: "https://www.cybermalveillance.gouv.fr/",
                    },
                    {
                        title: "SecNumacademie.gouv.fr",
                        type: "site",
                        thumbnail: "/img/ville/niort/risques-societaux/secnumacademie.png",
                        src: "https://secnumacademie.gouv.fr/",
                    },
                    {
                        title: "A propos de l'hameçonnage",
                        type: "pdf",
                        thumbnail: "/img/ville/niort/risques-societaux/affiche-hameconnage.png",
                        src: "https://cyber.gouv.fr/sites/default/files/document/phishing_hameconnage_infographie_anssi.pdf",
                        source: {
                            name: "Agence Nationale de la Sécurité des Systèmes d'Information",
                            url: "https://www.cyber.gouv.fr/"
                        }
                    },
                    {
                        title: "A propos des rançongiciels",
                        type: "pdf",
                        thumbnail: "/img/ville/niort/risques-societaux/affiche-rancongiciel.png",
                        src: "https://cyber.gouv.fr/sites/default/files/2022-08/rancongiciel_infographie_anssi%5B1%5D.pdf",
                        source: {
                            name: "Agence Nationale de la Sécurité des Systèmes d'Information",
                            url: "https://www.cyber.gouv.fr/"
                        }
                    }
                    
                ]
            }
        ]
    },
    {
        id: "risques-sanitaires",
        label: "Risques sanitaires",
        items: [
            {
                id: "pandemie",
                label: "Pandémie",
                infos: [
                    {
                        title: "QU’EST-CE QUE C’EST ?",
                        content: 
                            `<p>Il représente un risque immédiat ou à long terme pour la santé des populations nécessitant une réponse adaptée du système de santé. Parmi ces risques, on recense notamment les risques d’infection respiratoire aiguës (COVID 19, bronchiolite, grippe), les maladies
                            transmises par les moustiques.</p><p>Des mesures d’hygiène simples, individuelles et collectives peuvent contribuer à limiter le risque de transmission de ces maladies.</p>
                            <p>Voici les symptômes communs au Covid-19, à la bronchiolite et à la grippe :</p>
                            <ul><li>Fièvre</li><li>Toux</li><li>Maux de tête</li><li>Douleurs musculaires ou corporelles</li><li>Congestion nasale ou écoulement nasal</li><li>Mal de gorge</li></ul>
                            <p>Les vaccinations contre le Covid-19 et contre la grippe restent essentielles dans la prévention de la contamination, de la transmission et des formes graves de la maladie.</p>`
                    }
                ],
                medias: [
                    {
                        title: "Recommandations pour les infections respiratoires aiguës",
                        type: "pdf",
                        thumbnail: "/img/ville/niort/risques-sanitaires/recommandations-infections-respiratoires.png",
                        src: "https://www.info.gouv.fr/upload/media/content/0001/05/3f0b31283d87c64ac0dce24b75d43dd526ecfd3f.pdf",
                        source: {
                            name: "Site officiel du gouvernement",
                            url: "https://www.info.gouv.fr/"
                        }
                    },
                    {
                        title: "Protéger mon bébé des virus de l'hiver",
                        type: "video",
                        thumbnail: "/img/ville/niort/risques-sanitaires/proteger-contre-virus-hiver.png",
                        src: "https://www.youtube.com/embed/T1UwtFW3TxM?si=fwdZLAf_iihFKFU4",
                        source: {
                            name: "Compte officiel du ministère du Travail, de la Santé et des Solidarités",
                            url: "http://www.youtube.com/@MinistereSante"
                        }
                    }
                ]
            },
            {
                id: "lutte-anti-vectorielle",
                label: "Lutte anti-vectorielle",
                infos: [
                    {
                        title: "Maladie transmises par les moustiques",
                        content: 
                            `<p>Il s’agit de la lutte anti-vectorielle contre des insectes qui véhiculent certaines maladies pour éviter les risques de transmissions locales d’agents pathogènes.</p>
                            <p>Le moustique tigre est un vecteur potentiel des virus comme ceux du chikungunya, de la dengue et du zika.</p>`
                    }
                ],
                medias: [
                    {
                        title: "Carte où le moustique-tigre s'est installé",
                        type: "img",
                        src: "https://www.info.gouv.fr/upload/media/default/0001/07/dd59074f1d61782d45b36f302cb6b05ac1c5486e.jpg",
                        source: {
                            name: "Site officiel du gouvernement",
                            url: "https://www.info.gouv.fr/"
                        }
                    },
                    {
                        title: "Affiche informative sur le moustique tigre",
                        type: "img",
                        src: "https://www.info.gouv.fr/upload/media/default/0001/07/8a93860771d705ab6c39886ce8f2c5928eac0f21.png",
                        source: {
                            name: "Site officiel du gouvernement",
                            url: "https://www.info.gouv.fr/"
                        }
                    },
                    {
                        title: "Comment lutter contre les gîtes larvaires du moustique tigre",
                        type: "img",
                        src: "https://www.vivre-a-niort.com/fileadmin/user_upload/news/2022/shema_Page_1.jpeg",
                        source: {
                            name: "Vivre à Niort",
                            url: "https://www.vivre-a-niort.com/"
                        }
                    },
                    {
                        title: "Recommandations avant de partir en voyage",
                        type: "img",
                        src: "https://www.info.gouv.fr/upload/media/default/0001/07/ffe66d6582db8897c063696d9ccd4d33616240b2.png",
                        source: {
                            name: "Site officiel du gouvernement",
                            url: "https://www.info.gouv.fr/"
                        }
                    },
                    {
                        title: "Recommandations en rentrant de voyage",
                        type: "img",
                        src: "https://www.info.gouv.fr/upload/media/default/0001/07/8c5203ff798fb9363824292fff6d9aacf57b78e0.png",
                        source: {
                            name: "Site officiel du gouvernement",
                            url: "https://www.info.gouv.fr/"
                        }
                    }
                ]
            },
            {
                id: "radon",
                label: "Radon",
                infos: [
                    {
                        title: "QU’EST-CE QUE C’EST ?",
                        content: 
                            `<p>Le radon est un gaz radioactif issu de la désintégration de l'uranium et du radium présents naturellement dans le sol et les roches. En se désintégrant, il forme des descendants solides, eux-mêmes radioactifs. Ces descendants peuvent se fixer sur les aérosols de l'air et, une fois inhalés, se déposer le long des voies respiratoires en provoquant leur irradiation.</p>`
                    }
                ],
                medias: [
                    {
                        title: "Carte du potentiel radon des formations géologiques",
                        type: "img",
                        src: "https://www.irsn.fr/sites/default/files/images/connaissances/environnement/expertises-radioactivite-naturelle/radon/irsn_figure1-potentiel-radon-formations-geologiques.jpg",
                        source: {
                            name: "IRSN",
                            url: "https://www.irsn.fr/savoir-comprendre/environnement/cartographie-potentiel-radon-formations-geologiques"
                        }
                    },
                    {
                        title: "Comment savoir s'il y a du radon dans ma maison ?",
                        type: "video",
                        thumbnail: "/img/ville/niort/risques-sanitaires/irsn-radon.png",
                        src: "https://www.youtube.com/embed/ErXE0a52C3s?si=xAFN-ZGZwkO7LQds",
                        source: {
                            name: "Institut de Radioprotection et de Sûreté Nucleaire - IRSN",
                            url: "https://www.youtube.com/@IRSNvideo"
                        }
                    }
                ]
            }
        ],
    },
    {
        id: "catastrophes-naturelles",
        label: "Catastrophes naturelles",
        items: [
            {
                id: "catnats",
                label: "Catastrophes naturelles",
                infos: [
                    {
                        title: "QU’EST-CE QUE LA GARANTIE CAT-NAT ?",
                        content: 
                            `<p>L'assurance catastrophe naturelle est une extension de garantie obligatoire pour tous les contrats d'assurance de dommages (multirique habitation, tous risques auto, local, professionnel...) en dehors des contrats d'assurance des bateaux.</p>
                            <p>Selon l'article L125-1 du code des assurances, la garantie Cat-Nat prend en charge les « dommages matériels directs non assurables ayant eu pour cause déterminante l'intensité anormale d'un agent naturel, lorsque les mesures habituelles à prendre pour prévenir ces dommages n'ont pu empêcher leur survenance ou n'ont pu être prises. »</p>`
                    },
                    {
                        title: "QUELS SONT LES PHENOMENES NATURELS CONCERNES ?",
                        content: 
                            `<p>Liste non exhaustive :</p>
                                <ul>
                                    <li>inondations (par ruissellement, débordement de cours d'eau ou remontée de nappes);</li>
                                    <li>phénomènes liés à l'action de la mer (choc mécanique des vagues, submersion marine, etc...);</li>
                                    <li>sécheresse-réhydratation des sols (retrait-gonflement des argiles);</li>
                                    <li>mouvements de terrain;</li>
                                    <li>avalanches;</li>
                                    <li>séismes;</li>
                                    <li>volcanisme;</li>
                                    <li>vent cycloniques dont les vitesses sont supérieures à 145 km/h en moyenne sur 10 minutes, ou à 125 km/h en rafales</li>
                                </ul>
                            <p>Les dommages provoqués par les vents violents qui ne réunissent pas les caratéristiques des vents cycloniques (tempêtes, tornades), de même que les dommages causés par la grêle ou le poids de la neige sont couverts par d'autres garanties, incluses dans les contrats dommages aux biens de manière obligatoire (tempête) ou optionnelles (grêle et neige).</p>`
                    },
                    {
                        title: "COMMENT PUIS-JE ME DECLARER ?",
                        content:
                            `<p>Vous devez faire votre déclaration de sinistre à votre compagnie d'assurance et à la mairie dès que vous avez connaissance de l'évènement, et <strong>au plus tard 30 jours</strong> (et non plus 10 jours) après la publication de l'arrêté de catastrophe naturelle au <i>Journal officiel</i>.</p>
                            <p>Si vous avez souscrit l'assurance contre les pertes d'exploitation, vous devez faire une déclaration du sinistre pour cette garantie dans le même délai.</p>
                            <p>La déclaration doit être envoyée par lettre recommandée, de préférence avec accusé de réception. Il faut prévoir si nécessaire une copie de ce courrier à votre agent d'assurances ou votre courtier.</p>
                            <p>Vous devez indiquer dans la lettre les éléments suivants :</p>
                                <ul>
                                    <li>Nom, prénom et adresse</li>
                                    <li>Numéro de contrat d'assurance</li>
                                    <li>Description du sinitre (nature, date, heure, lieu)</li>
                                    <li>Liste chiffrée de tous les objets perdus ou endommagés, accompagnés des documents permettant de prouver l'existence et la valeur des biens (factures, photographies par exemple)</li>
                                    <li>Estimation de votre préjudice, si vous avez souscrit l'assurance contre les pertes d'exploitation</li>
                                    <li>Dégâts causés à des tiers (par exemple si un arbre de votre propriété est tombé et a occasionné des dégâts chez un voisin)</li>
                                    <li>Coordonnées des victimes s'il y en a</li>
                                </ul>
                                `
                    },
                    {
                        title: "A SAVOIR",
                        content: 
                            `<p>Si vous prenez en charge la réparation (partielle ou totale) de vos biens, il faut conserver les factures d'achat de matériaux pour qu'elles soient prises en compte par l'assureur.</p>
                            <p>Conservez les objets endommagés, car ils seront peut-être examinés par l'assureur ou l'expert désigné pendant l'expertise.</p>`
                    },
                    {
                        title: "PROCEDURE A SUIVRE EN CAS D'APPARITION DE FISSURES IMPORTANTES",
                        content:
                            `<p>Les propriétaires s'adressent à la mairie de leur domicile pour signifier les désordres apparus sur leur maison (service Hygiène et Santé 05.49.78.79.80)</p>
                            <p>Après constatation que de nombreux administrés sont touchés par ces désordres, la commune sollicite le classement en état de catastrohpe naturelle aurpès du Préfet du département.</p>
                            <p>Le Préfet établit un dossier qui est examiné en commission interministérielle. C'est à ce stade qu'un avis sur l'état ou l'absence de catastrophe naturelle sera émis.</p>
                            <p>Lorsque l'avis est favorable, il est concrétisé par la publication d'un arrêté interministériel au Journal Officiel qui ouvre droit à une possibilité d'indemnisation au titre des contrats d'assurance Multirisques-Habitation. Les arrêtés mentionnent « mouvements de terrains consécutifs à la sécheresse et à la réhydratation des sols... » et délimitent la période pendant laquelle la sécheresse a été particulièrement active.</p>
                            <p><strong>Vos démarche auprès de votre asssurance :</strong></p>
                            <p>Les propriétaires doivent déclarer le sinistre à leur assurance dans un délai de 30 jours suivant la publication de l'arrêté au Journal Officiel. Un lien de causalité doit exister entre la catastrophe constatée par l'arrêté et les dommages subis par l'assuré.</p>
                            <p>Les dates de déclaration des désordres doivent correspondre aux périodes concernées par l'arrêté. La reconnaissance d'une commune en état de catastrophe naturelle n'implique pas systématiquement une indemnisation. C'est l'assureur, avec l'aide d'un expert, qui déterminera si les désordres sont réellement liés à la sécheresse.</p>`
                    },
                    {
                        title: "OBLIGATIONS",
                        content:
                            `<p>Le vendeur ou le bailleur d'un immeuble bâti ayant subi un sinistre indemnisé au titre d'une catastrophe naturelle ou technologique a l'obligation d'en informer l'acheteur ou le locataire.</p>
                            <p>Les sinistres concernés sont : </p>
                                <ul>
                                    <li>inondation</li>
                                    <li>coulée de boue</li>
                                    <li>orage violent</li>
                                    <li>mouvements de terrains différentiels consécutifs à la sécheresse et à la réhydratation des sols argileux</li>
                                    <li>accident industriel</li>
                                    <li>rupture de barrage</li>
                                    <li>accident de transport de marchandises dangereuses</li> 
                                </ul>`
                    }
                ],
                medias: [
                    {
                        title: "Dispositifs d'indemnisation dans le cas de catastrophes naturelles",
                        type: "pdf",
                        thumbnail: "/img/ville/niort/catnats/indemnisation-catnat.png",
                        src: "https://www.georisques.gouv.fr/sites/default/files/2022-08/CatNat_Proc%C3%A9dures%20Indemnisation.pdf",
                        source: {
                            name: "Géorisques",
                            url: "https://www.georisques.gouv.fr/"
                        }
                    },
                    {
                        title: "Comment bénéficier de la garantie catastrophe naturelle ?",
                        type: "video",
                        thumbnail: "/img/ville/niort/catnats/beneficier-garantie-catnat.png",
                        src: "https://geo.dailymotion.com/player.html?video=x6dk4hi",
                        source: {
                            name: "Ministère de l'Intérieur et des Outre-mer",
                            url: "https://www.dailymotion.com/Ministere_interieur"
                        }
                    }
                ]
            }
        ]
    },
]